import { Routes } from '@angular/router';
import { AdministrationGuard } from '@core/guards/administration.guard';
import { AdminGroupDetailsGuard } from '@core/permissions/guards/admin-group-details.guard';
import { RemindersGuard } from '@core/permissions/guards/reminders.guard';
import { SettingsGuard } from '@core/permissions/guards/settings.guard';

export const APP_ROUTES: Routes = [
  {
    path: 'groups',
    loadChildren: () => import('@features/groups/groups.routes').then(m => m.GROUPS_ROUTES),
  },
  {
    path: 'reminders',
    loadChildren: () => import('@features/reminders/reminders.routes').then(m => m.REMINDERS_ROUTES),
    canActivate: [RemindersGuard],
  },
  {
    path: 'administration',
    loadChildren: () => import('@features/administration/administration.routes').then(m => m.ADMINISTRATION_ROUTES),
    canActivate: [AdministrationGuard],
  },
  {
    path: 'administration/groups/:id',
    loadComponent: () =>
      import('@features/groups/pages/group-view/group-view.component').then(c => c.GroupViewComponent),
    canActivate: [AdminGroupDetailsGuard],
  },
  {
    path: 'settings',
    loadChildren: () => import('@features/settings/settings.routes').then(m => m.SETTINGS_ROUTES),
    canActivate: [SettingsGuard],
  },
  {
    path: 'tg-users',
    loadChildren: () => import('@features/tg-users/tg-users.routes').then(m => m.TG_USERS_LIST_ROUTES),
    canActivate: [AdministrationGuard],
  },
  {
    path: '**',
    redirectTo: 'groups',
    pathMatch: 'full',
  },
];
